import React, { useState } from "react"
import * as styles from "./Lists.module.css"
import useDeviceType from "../../../../hooks/useDeviceType"
import classNames from "classnames"
import { Link } from "gatsby"

type ListsProps = {
  details: Array<{
    image: any
    title: string
    date: string
    description: string
    link: string
  }>
}

const Lists = ({ details }: ListsProps) => {
  const [activePage, setActivePage] = useState(0)
  const [startX, setStartX] = useState(0)

  const DeviceType = useDeviceType()

  // Touch Start
  const handleTouchStart: React.TouchEventHandler<HTMLDivElement> = e => {
    setStartX(e.touches[0].clientX)
  }

  // Touch End
  const handleTouchEnd: React.TouchEventHandler<HTMLDivElement> = e => {
    const currentX = e.changedTouches[0].clientX
    if (activePage > 0 && currentX > startX) {
      // Pre Page
      setActivePage(preActivePage => preActivePage - 1)
    } else if (activePage < details.length - 1 && currentX < startX) {
      // Next Page
      setActivePage(preActivePage => preActivePage + 1)
    }
    setStartX(0)
  }

  // Filter Page
  const filterDetails = details.filter((_, index) => {
    if (DeviceType === "mobile" || DeviceType === "tablet") {
      return activePage === index
    }
    return true
  })

  return (
    <>
      {filterDetails.map(({ image, title, date, description, link }, index) => (
        <Link key={index} to={link}>
          <div
            className={classNames(styles.list, {
              [styles.touchStart]: startX,
            })}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            {image.src ? <img {...image} /> : <>{image}</>}
            <div className={styles.content}>
              <h3>{title}</h3>
              <span>{date}</span>
              <p>{description}</p>
            </div>
          </div>
        </Link>
      ))}

      {(DeviceType === "mobile" || DeviceType === "tablet") && (
        <div className={styles.sliderCircleContent}>
          {details.map((_, index) => (
            <div
              key={index}
              className={classNames(styles.circle, {
                [styles.active]: activePage === index,
              })}
              onClick={() => setActivePage(index)}
            />
          ))}
        </div>
      )}
    </>
  )
}

export default Lists
